var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"wrapper"},[(!_vm.isIframe)?_c('Header'):_vm._e(),_c('Main')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }